import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allHeatPumpDevices: {},
    singleHeatpumpDevice: {},
    deviceHistory: []
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_HEAT_PUMP_DEVICES_REQUEST :
            return { ...state, isLoading: true }

        case actionsTypes.GET_HEAT_PUMP_DEVICES_SUCCESS:
            return { ...state, isLoading: false, allHeatPumpDevices: action.payload || {} }

        case actionsTypes.GET_HEAT_PUMP_DEVICES_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_SINGLE_HEAT_PUMP_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_SINGLE_HEAT_PUMP_SUCCESS:
            return { ...state, isLoading: false, singleHeatpumpDevice: action.payload || {} }

        case actionsTypes.GET_SINGLE_HEAT_PUMP_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_HEAT_PUMP_DEVICE_HISTORY_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_HEAT_PUMP_DEVICE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, deviceHistory: action.payload || [] }

        case actionsTypes.GET_HEAT_PUMP_DEVICE_HISTORY_FAILED:
            return { ...state, isLoading: false }

        default:
            return state
    }
}